export default "__VITE_ASSET__DfKNHnQC__"